var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("dialogue", {
        attrs: {
          title: "Success",
          paragraph: _vm.save_dialogue_text,
          button_names: ["Accept"],
          show: _vm.save_dialogue
        },
        on: { cancel: _vm.saveDialogue }
      }),
      _vm._v(" "),
      _c("dialogue", {
        attrs: {
          title: "Error",
          paragraph: _vm.error_dialogue_text,
          button_names: ["Accept"],
          show: _vm.error_dialogue
        },
        on: { cancel: _vm.errorDialogue }
      }),
      _vm._v(" "),
      _c("div", { staticStyle: { display: "flex", "flex-direction": "row" } }, [
        _vm.jobOrderSearch == ""
          ? _c(
              "div",
              {
                staticStyle: {
                  height: "calc(100vh - 50px)",
                  "overflow-x": "scroll",
                  "flex-grow": "1"
                }
              },
              [
                _c("layout-1", {
                  attrs: {
                    table_name: "Job Orders",
                    id: _vm.id2,
                    searchbar: true,
                    termchange: true,
                    navbar: true,
                    button_name: "Schedules",
                    button_perm: "9"
                  },
                  on: { select: _vm.selectJobOrder }
                })
              ],
              1
            )
          : _c(
              "div",
              {
                staticStyle: {
                  height: "calc(100vh - 50px)",
                  "overflow-x": "scroll",
                  "flex-grow": "1"
                }
              },
              [
                _c("layout-1", {
                  staticStyle: {
                    height: "calc(100vh - 50px)",
                    "overflow-x": "scroll",
                    "flex-grow": ".5"
                  },
                  attrs: {
                    table_name: "Job Schedules",
                    id: _vm.id3,
                    term: _vm.jobOrderSearch,
                    termchange: true,
                    navbar: true,
                    nav_items: ["Cancel"],
                    nav_item_perms: ["9"],
                    button_name: "Assign",
                    button_perm: "9"
                  },
                  on: { select: _vm.selectSchedule }
                })
              ],
              1
            ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "scroll",
            staticStyle: {
              flex: "0 0 35%",
              height: "calc(100vh - 75px)",
              "margin-right": "10px"
            }
          },
          [
            _c(
              "div",
              {
                staticClass: "centered bordered",
                staticStyle: { margin: "0" }
              },
              [
                _c(
                  "table",
                  {
                    key: _vm.update_key,
                    staticStyle: { margin: "auto", width: "99%" }
                  },
                  [
                    _c("tr", [
                      _c("td", [
                        _vm._v(
                          "\n                                WONumber\n                            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", [_vm._v(_vm._s(_vm.table_data[3]))])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                                JobScheduleID\n                            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                                " +
                            _vm._s(_vm.table_data[2]) +
                            "\n                            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c(
                          "button",
                          {
                            on: {
                              click: function($event) {
                                return _vm.selectSchedule("0")
                              }
                            }
                          },
                          [_vm._v("Unassign")]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [
                        _vm._v(
                          "\n                                Type\n                            "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        { attrs: { colspan: "3" } },
                        [
                          _c("autocomplete", {
                            staticStyle: { width: "100%" },
                            attrs: { id: "typeSearch", type: 30 },
                            model: {
                              value: _vm.table_data[0],
                              callback: function($$v) {
                                _vm.$set(_vm.table_data, 0, $$v)
                              },
                              expression: "table_data[0]"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", { staticStyle: { "padding-right": "5px" } }, [
                        _vm._v(
                          "\n                                ReportPage\n                            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.table_data[1],
                              expression: "table_data[1]"
                            }
                          ],
                          staticStyle: { width: "100%" },
                          attrs: { id: "reportSearch" },
                          domProps: { value: _vm.table_data[1] },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(_vm.table_data, 1, $event.target.value)
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "text-align": "right",
                            "vertical-align": "middle",
                            "padding-right": "5px"
                          }
                        },
                        [
                          _vm._v(
                            "\n                                kWh\n                            "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("td", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.table_data[4],
                              expression: "table_data[4]"
                            }
                          ],
                          staticStyle: { width: "100%" },
                          attrs: { id: "kilowattSearch" },
                          domProps: { value: _vm.table_data[4] },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(_vm.table_data, 4, $event.target.value)
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("td")
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", { staticStyle: { "padding-right": "5px" } }, [
                        _vm._v(
                          "\n                                kW\n                            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.table_data[5],
                              expression: "table_data[5]"
                            }
                          ],
                          staticStyle: { width: "100%" },
                          attrs: { id: "reportSearch" },
                          domProps: { value: _vm.table_data[5] },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(_vm.table_data, 5, $event.target.value)
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "text-align": "right",
                            "vertical-align": "middle",
                            "padding-right": "5px"
                          }
                        },
                        [
                          _vm._v(
                            "\n                                Date Time\n                            "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c("datetime", {
                            staticStyle: { width: "100%" },
                            attrs: { id: "kilowattSearch" },
                            model: {
                              value: _vm.table_data[6],
                              callback: function($$v) {
                                _vm.$set(_vm.table_data, 6, $$v)
                              },
                              expression: "table_data[6]"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("td")
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.checkboxData, function(col, i) {
                      return _c("tr", { staticStyle: { height: "30px" } }, [
                        _c("td", { staticStyle: { height: "30px" } }, [
                          _vm._v(
                            "\n                                " +
                              _vm._s(col[0]) +
                              "\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticStyle: { height: "30px" } }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: col[1],
                                expression: "col[1]"
                              }
                            ],
                            staticStyle: { width: "30px" },
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(col[1])
                                ? _vm._i(col[1], null) > -1
                                : col[1]
                            },
                            on: {
                              click: function($event) {
                                return _vm.setCheckbox(i, 1)
                              },
                              change: function($event) {
                                var $$a = col[1],
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(col, 1, $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        col,
                                        1,
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(col, 1, $$c)
                                }
                              }
                            }
                          }),
                          _vm._v("Yes"),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: col[2],
                                expression: "col[2]"
                              }
                            ],
                            staticStyle: { width: "30px" },
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(col[2])
                                ? _vm._i(col[2], null) > -1
                                : col[2]
                            },
                            on: {
                              click: function($event) {
                                return _vm.setCheckbox(i, 2)
                              },
                              change: function($event) {
                                var $$a = col[2],
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(col, 2, $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        col,
                                        2,
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(col, 2, $$c)
                                }
                              }
                            }
                          }),
                          _vm._v("No")
                        ]),
                        _vm._v(" "),
                        _c("td"),
                        _vm._v(" "),
                        _c("td"),
                        _vm._v(" "),
                        i == _vm.checkboxData.length - 1
                          ? _c("td", [
                              _c(
                                "button",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.setDocData()
                                    }
                                  }
                                },
                                [_vm._v("Save")]
                              )
                            ])
                          : _vm._e()
                      ])
                    })
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "centered" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.cropPosY,
                    expression: "cropPosY"
                  }
                ],
                staticClass: "slider",
                staticStyle: { width: "250px" },
                attrs: {
                  type: "range",
                  min: "0",
                  max: "500",
                  value: "0",
                  id: "skew"
                },
                domProps: { value: _vm.cropPosY },
                on: {
                  __r: function($event) {
                    _vm.cropPosY = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "centered" },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.cropNegX,
                      expression: "cropNegX"
                    }
                  ],
                  staticClass: "slider",
                  attrs: {
                    type: "range",
                    min: "0",
                    max: "500",
                    value: "0",
                    orient: "vertical",
                    id: "skew"
                  },
                  domProps: { value: _vm.cropNegX },
                  on: {
                    __r: function($event) {
                      _vm.cropNegX = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c("document", {
                  ref: "doc",
                  staticStyle: { width: "70%", height: "auto" },
                  attrs: {
                    dir: "doc_" + _vm.docID + ".jpg",
                    save: _vm.save,
                    brightness: parseInt(_vm.brightness),
                    contrast: parseInt(_vm.contrast),
                    rotation: parseFloat(_vm.rotation) + parseFloat(_vm.skew),
                    grid: _vm.grid,
                    translateX: parseInt(_vm.translateX),
                    translateY: parseInt(_vm.translateY),
                    scale: parseFloat(_vm.scale),
                    crop: [
                      parseInt(_vm.cropPosX),
                      parseInt(_vm.cropNegX),
                      parseInt(_vm.cropPosY),
                      parseInt(_vm.cropNegY)
                    ],
                    doc_id: _vm.docID
                  }
                }),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.cropPosX,
                      expression: "cropPosX"
                    }
                  ],
                  staticClass: "slider",
                  attrs: {
                    type: "range",
                    min: "0",
                    max: "500",
                    value: "0",
                    orient: "vertical",
                    id: "skew"
                  },
                  domProps: { value: _vm.cropPosX },
                  on: {
                    __r: function($event) {
                      _vm.cropPosX = $event.target.value
                    }
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "centered" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.cropNegY,
                    expression: "cropNegY"
                  }
                ],
                staticClass: "slider",
                staticStyle: { width: "250px" },
                attrs: {
                  type: "range",
                  min: "0",
                  max: "500",
                  value: "0",
                  id: "skew"
                },
                domProps: { value: _vm.cropNegY },
                on: {
                  __r: function($event) {
                    _vm.cropNegY = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "bordered" }, [
              _vm.grid == false
                ? _c(
                    "button",
                    {
                      staticStyle: {
                        height: "20px",
                        float: "left",
                        margin: "10px",
                        "font-size": "14px"
                      },
                      on: {
                        click: function($event) {
                          _vm.grid = !_vm.grid
                        }
                      }
                    },
                    [
                      _c("font-awesome-icon", { attrs: { icon: "border-all" } })
                    ],
                    1
                  )
                : _c(
                    "button",
                    {
                      staticStyle: {
                        height: "20px",
                        float: "left",
                        margin: "10px",
                        "background-color": "#a7a7a7",
                        "font-size": "14px"
                      },
                      on: {
                        click: function($event) {
                          _vm.grid = !_vm.grid
                        }
                      }
                    },
                    [
                      _c("font-awesome-icon", { attrs: { icon: "border-all" } })
                    ],
                    1
                  ),
              _vm._v(" "),
              _c("div", { staticClass: "centered" }, [
                _c(
                  "button",
                  {
                    staticStyle: {
                      width: "200px",
                      height: "20px",
                      "margin-right": "10px",
                      "margin-left": "10px",
                      "font-size": "14px"
                    },
                    on: {
                      click: function($event) {
                        return _vm.rotate(false)
                      }
                    }
                  },
                  [_vm._v("Rotate -90")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticStyle: {
                      width: "200px",
                      height: "20px",
                      "margin-right": "10px",
                      "margin-left": "10px",
                      "font-size": "14px"
                    },
                    on: {
                      click: function($event) {
                        return _vm.rotate(true)
                      }
                    }
                  },
                  [_vm._v("Rotate 90")]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "centered" }, [
                _c("table", { staticStyle: { "table-layout": "fixed" } }, [
                  _c("tr", [
                    _c("td", { staticStyle: { width: "200px" } }, [
                      _c("div", { staticStyle: { "font-size": "14px" } }, [
                        _vm._v(
                          "\n                                        Skew : " +
                            _vm._s(_vm.skew) +
                            "°\n                                    "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("td", { staticStyle: { width: "30px" } }, [
                      _c(
                        "button",
                        {
                          staticStyle: { height: "20px", "font-size": "14px" },
                          on: {
                            click: function($event) {
                              _vm.skew = 0
                            }
                          }
                        },
                        [_vm._v("0")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.skew,
                            expression: "skew"
                          }
                        ],
                        staticClass: "slider",
                        attrs: {
                          type: "range",
                          min: "-45",
                          max: "45",
                          step: "0.1",
                          value: "0",
                          id: "skew"
                        },
                        domProps: { value: _vm.skew },
                        on: {
                          __r: function($event) {
                            _vm.skew = $event.target.value
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [
                      _c("div", { staticStyle: { "font-size": "14px" } }, [
                        _vm._v(
                          "\n                                        Translate : (" +
                            _vm._s(_vm.translateX) +
                            "," +
                            _vm._s(_vm.translateY) +
                            ")px\n                                    "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("td", { staticStyle: { width: "30px" } }, [
                      _c(
                        "button",
                        {
                          staticStyle: { height: "20px", "font-size": "14px" },
                          on: {
                            click: function($event) {
                              _vm.translateX = 0
                              _vm.translateY = 0
                            }
                          }
                        },
                        [_vm._v("0")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.translateX,
                            expression: "translateX"
                          }
                        ],
                        staticClass: "slider",
                        staticStyle: { width: "calc(50% - 20px)" },
                        attrs: {
                          type: "range",
                          min: "-500",
                          max: "500",
                          value: "0",
                          id: "translateX"
                        },
                        domProps: { value: _vm.translateX },
                        on: {
                          __r: function($event) {
                            _vm.translateX = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.translateY,
                            expression: "translateY"
                          }
                        ],
                        staticClass: "slider",
                        staticStyle: {
                          width: "calc(50% - 20px)",
                          float: "right"
                        },
                        attrs: {
                          type: "range",
                          min: "-500",
                          max: "500",
                          value: "0",
                          id: "translateY"
                        },
                        domProps: { value: _vm.translateY },
                        on: {
                          __r: function($event) {
                            _vm.translateY = $event.target.value
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [
                      _c("div", { staticStyle: { "font-size": "14px" } }, [
                        _vm._v(
                          "\n                                        Scale : " +
                            _vm._s(_vm.scale) +
                            "%\n                                    "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("td", { staticStyle: { width: "30px" } }, [
                      _c(
                        "button",
                        {
                          staticStyle: { height: "20px", "font-size": "14px" },
                          on: {
                            click: function($event) {
                              _vm.scale = 100
                            }
                          }
                        },
                        [_vm._v("0")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.scale,
                            expression: "scale"
                          }
                        ],
                        staticClass: "slider",
                        attrs: {
                          type: "range",
                          min: "50",
                          max: "150",
                          step: "0.1",
                          value: "0",
                          id: "scale"
                        },
                        domProps: { value: _vm.scale },
                        on: {
                          __r: function($event) {
                            _vm.scale = $event.target.value
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [
                      _c("div", { staticStyle: { "font-size": "14px" } }, [
                        _vm._v(
                          "\n                                        Brightness : " +
                            _vm._s(_vm.brightness) +
                            "%\n                                    "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("td", { staticStyle: { width: "30px" } }, [
                      _c(
                        "button",
                        {
                          staticStyle: { height: "20px", "font-size": "14px" },
                          on: {
                            click: function($event) {
                              _vm.brightness = 0
                            }
                          }
                        },
                        [_vm._v("0")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.brightness,
                            expression: "brightness"
                          }
                        ],
                        staticClass: "slider",
                        attrs: {
                          type: "range",
                          min: "-100",
                          max: "100",
                          value: "50",
                          id: "brightness"
                        },
                        domProps: { value: _vm.brightness },
                        on: {
                          __r: function($event) {
                            _vm.brightness = $event.target.value
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [
                      _c("div", { staticStyle: { "font-size": "14px" } }, [
                        _vm._v(
                          "\n                                        Contrast : " +
                            _vm._s(_vm.contrast) +
                            "%\n                                    "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("td", { staticStyle: { width: "30px" } }, [
                      _c(
                        "button",
                        {
                          staticStyle: { height: "20px", "font-size": "14px" },
                          on: {
                            click: function($event) {
                              _vm.contrast = 0
                            }
                          }
                        },
                        [_vm._v("0")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.contrast,
                            expression: "contrast"
                          }
                        ],
                        staticClass: "slider",
                        attrs: {
                          type: "range",
                          min: "-100",
                          max: "100",
                          value: "0",
                          id: "contrast"
                        },
                        domProps: { value: _vm.contrast },
                        on: {
                          __r: function($event) {
                            _vm.contrast = $event.target.value
                          }
                        }
                      })
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "centered" }, [
                _c(
                  "button",
                  {
                    staticStyle: {
                      width: "200px",
                      height: "20px",
                      "margin-right": "10px",
                      "margin-left": "10px",
                      "font-size": "14px"
                    },
                    on: {
                      click: function($event) {
                        _vm.save = !_vm.save
                      }
                    }
                  },
                  [_vm._v("Save")]
                )
              ])
            ])
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cfdebd00", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cfdebd00","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/layout_6.vue
// module id = 758
// module chunks = 0